import React from "react"
import { Employee } from "../../Objects/Employee/Employee"
import style from "./CardEmployeeRegister.module.css"
import { useLoadImage } from "../../hooks/useLoadImage"
import { type IconProp } from "@fortawesome/fontawesome-svg-core"
import { formatDateToString } from "../../Objects/Generics/Helps"
import GetSpace from "../../utils/space"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface CardEmployeeRegisterProps {
  employee: Employee
  title?: string
  date: string
  icon: IconProp
  iconColor?: string
  color?: string
}

export const CardEmployeeRegister: React.FC<CardEmployeeRegisterProps> = ({
  color,
  iconColor,
  icon,
  employee,
  title = "",
  date,
}) => {
  const { errorOccurred, handleErrorLoad, handleLoad } = useLoadImage(employee.iconUrl)

  let dateFinal = formatDateToString(date)
  if (dateFinal === "Invalid Date") dateFinal = ""

  return (
    <div
      className="
        bg-white
        rounded-lg
        shadow-sm
        hover:shadow-lg
        p-1
      "
    >
      <div className="flex items-center gap-4">
        {!errorOccurred ? (
          <img
            src={employee.iconUrl}
            alt={employee.personEntity.name}
            onLoad={handleLoad}
            onError={handleErrorLoad}
            className="
              w-8 h-8
              rounded-full
              object-cover
              border-2 border-gray-200
              shadow-sm
            "
          />
        ) : (
          <div
            className="
              w-8 h-8
              rounded-full
              bg-gray-200
              flex items-center justify-center
              text-gray-500 text-sm font-semibold
            "
          >
            {employee.personEntity.name.charAt(0)}
          </div>
        )}

        <div className="flex flex-col flex-1">
          <div className="flex items-center gap-2">
            <span className="text-base font-medium text-gray-800">{employee.personEntity.name}</span>
          </div>

          {(title || dateFinal) && (
            <span className="text-xs font-medium text-gray-500 mt-1">
              {title} {dateFinal}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export const CardEmployeeRegisterInLine: React.FC<CardEmployeeRegisterProps> = ({
  iconColor,
  icon,
  employee,
  date,
}) => {
  let dateFinal = formatDateToString(date)

  if (dateFinal === "Invalid Date") {
    dateFinal = ""
  }

  return (
    <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
      <div className={style.cardInLine}>
        <FontAwesomeIcon color={iconColor ?? "black"} style={{ fontSize: "12px" }} icon={icon} />

        <GetSpace left={5} />

        <span className={style.cardInLineTitle}>{employee.personEntity.name}</span>

        <GetSpace left={5} />

        <span className={style.cardInLineTitle}>{dateFinal}</span>
      </div>
    </Animate>
  )
}
